import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox, CheckboxProps } from '@sato/components';

export const HookFormCheckbox = (props: { name: string } & CheckboxProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field: { value, ...fieldProps }, fieldState }) => (
        <Checkbox
          {...props}
          {...fieldProps}
          isSelected={!!value}
          error={fieldState.error?.message}
        />
      )}
    />
  );
};
